import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { MarketplaceProvider } from '../../providers/marketplace/marketplace';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { SingleMarketPlacePage } from '../single-market-place/single-market-place';
import { TranslateService } from '@ngx-translate/core';


/**
 * Generated class for the MarketplacesearchPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-marketplacesearch',
  templateUrl: 'marketplacesearch.html',
})
export class MarketplacesearchPage {
  matches = [];
  selected: any;
  marketuuid: any;
  name:any;
  societyuuid:any;
  uuid:any;
  message:any;

  constructor(public navCtrl: NavController,
    private marketplaceprovider: MarketplaceProvider,
    private translate: TranslateService,
    private viewCtrl: ViewController,
    public navParams: NavParams) {
      // this.name = this.navParams.get("name");
      this.marketuuid = this.navParams.get("marketuuid");
      this.societyuuid =this.navParams.get("societyuuid");
      // this.uuid = this.navParams.get("uuid");
      this.getResults('');
  }


  getResults(query) {
    this.matches = [];
    //  this.selected = {
    //    id: '',
    //    description: ''
    //  };

    this.marketplaceprovider.search(this.marketuuid, query).then(val => {
      this.message=val['message'];
      console.log(this.message)
      this.matches = val['data'];
      console.log(this.matches)
    }, (err) => {
      console.log('err: ', err);
    });
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  singlePage(item){
  this.navCtrl.push(SingleMarketPlacePage, {
    societyuuid:this.societyuuid,
    marketuuid:this.marketuuid,
    categoryuuid:this.uuid,
    itemid:item.uuid,
    itemSingle:item
  });
}

  //  this.marketplaceprovider.get('serverUrl', {query: this.query}).then((res:any) => { 
  ionViewDidLoad() {
    console.log('ionViewDidLoad MarketplacesearchPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/marketplacesearch/marketplacesearch.ts